module.exports = __webpack_public_path__ + "img/crisp.e3ce8643.png";